import React from 'react';

const RandomizerObjectPosition = ({ state, callbacks }) => {
  return (
    <div className="w-full bg-transparent p-0 space-y-4">
      <p className="text-sm text-dark-text-muted leading-relaxed">
        Die Position der Objekte wird bei jedem Frame zufällig innerhalb des definierten Bereichs geändert.
      </p>

      {state.randomizers.objectPosition && (
        <>
          <div>
            <label className="block mb-2 text-xs font-medium text-dark-text-muted tracking-tight">X-Bereich</label>
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-1.5">
                <input
                  type="number"
                  value={state.modelSpawn.minPosition.x}
                  onChange={(e) => callbacks.setModelSpawn({
                    ...state.modelSpawn,
                    minPosition: { ...state.modelSpawn.minPosition, x: parseFloat(e.target.value) || 0 }
                  })}
                  step="0.1"
                  className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
                />
                <span className="text-xs text-dark-text-muted tracking-tight font-medium">Min</span>
              </div>
              <div className="space-y-1.5">
                <input
                  type="number"
                  value={state.modelSpawn.maxPosition.x}
                  onChange={(e) => callbacks.setModelSpawn({
                    ...state.modelSpawn,
                    maxPosition: { ...state.modelSpawn.maxPosition, x: parseFloat(e.target.value) || 0 }
                  })}
                  step="0.1"
                  className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
                />
                <span className="text-xs text-dark-text-muted tracking-tight font-medium">Max</span>
              </div>
            </div>
          </div>

          <div>
            <label className="block mb-2 text-xs font-medium text-dark-text-muted tracking-tight">Y-Bereich</label>
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-1.5">
                <input
                  type="number"
                  value={state.modelSpawn.minPosition.y}
                  onChange={(e) => callbacks.setModelSpawn({
                    ...state.modelSpawn,
                    minPosition: { ...state.modelSpawn.minPosition, y: parseFloat(e.target.value) || 0 }
                  })}
                  step="0.1"
                  className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
                />
                <span className="text-xs text-dark-text-muted tracking-tight font-medium">Min</span>
              </div>
              <div className="space-y-1.5">
                <input
                  type="number"
                  value={state.modelSpawn.maxPosition.y}
                  onChange={(e) => callbacks.setModelSpawn({
                    ...state.modelSpawn,
                    maxPosition: { ...state.modelSpawn.maxPosition, y: parseFloat(e.target.value) || 0 }
                  })}
                  step="0.1"
                  className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
                />
                <span className="text-xs text-dark-text-muted tracking-tight font-medium">Max</span>
              </div>
            </div>
          </div>

          <div>
            <label className="block mb-2 text-xs font-medium text-dark-text-muted tracking-tight">Z-Bereich</label>
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-1.5">
                <input
                  type="number"
                  value={state.modelSpawn.minPosition.z}
                  onChange={(e) => callbacks.setModelSpawn({
                    ...state.modelSpawn,
                    minPosition: { ...state.modelSpawn.minPosition, z: parseFloat(e.target.value) || 0 }
                  })}
                  step="0.1"
                  className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
                />
                <span className="text-xs text-dark-text-muted tracking-tight font-medium">Min</span>
              </div>
              <div className="space-y-1.5">
                <input
                  type="number"
                  value={state.modelSpawn.maxPosition.z}
                  onChange={(e) => callbacks.setModelSpawn({
                    ...state.modelSpawn,
                    maxPosition: { ...state.modelSpawn.maxPosition, z: parseFloat(e.target.value) || 0 }
                  })}
                  step="0.1"
                  className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
                />
                <span className="text-xs text-dark-text-muted tracking-tight font-medium">Max</span>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default RandomizerObjectPosition;
